<template>
    <div class="viewport perspective" v-resize.debounce="onResize">
        <slider
            :update-slider-pos="updateSliderPos"
            :override-pos="sliderOverridePos"
        />
        <slot></slot>
        <canvas class="layer3D"></canvas>
    </div>
</template>

<script>
import { gsap } from 'gsap';
import {
    PerspectiveCamera,
    WebGLRenderer,
    sRGBEncoding,
    CineonToneMapping,
} from 'three';
import OrbitControls from 'three-orbitcontrols';
import resize from 'vue-resize-directive';
import { mapState, mapActions } from 'vuex';
import Slider from './slider';
import { isMobileOnly } from 'mobile-device-detect';
export default {
    directives: {
        resize,
    },
    components: { Slider },
    data() {
        return {
            sliderOverridePos: 0,
            cameraController: {
                x: 0,
                y: 0,
                z: 0,
                fov: 0,
            },
            sliderPos: 0,
        };
    },
    computed: {
        ...mapState('spinner', [
            'sceneLeft',
            'sceneRight',
            'renderer',
            'camera',
            'cameraLookat',
            'loadFinished',
        ]),
    },
    mounted() {
        this.width = this.$el.offsetWidth;
        this.height = this.$el.offsetHeight;
        this.aspect = window.innerWidth / window.innerHeight;

        this.setup({
            camera: new PerspectiveCamera(40, this.aspect, 0.1, 3000),
            renderer: new WebGLRenderer({
                alpha: true,
                antialias: true,
                // preserveDrawingBuffer: true,
                canvas: this.$el.getElementsByTagName('canvas')[0],
            }),
        });

        this.$nextTick(() => {
            // this.sceneLeft.background = new Color(0xff00ff);
            const distance = isMobileOnly ? 30 : 22;
            this.camera.position.set(0, 4, distance);
            this.camera.lookAt(this.cameraLookat);

            this.renderer.setPixelRatio(window.devicePixelRatio);
            this.renderer.setSize(this.width, this.height);
            this.renderer.setScissorTest(true);
            this.renderer.outputEncoding = sRGBEncoding;
            this.renderer.gammaInput = true;
            this.renderer.gammaOutput = true;
            // this.renderer.gammaFactor = 1.5;
            this.renderer.toneMapping = CineonToneMapping;
            this.renderer.toneMappingExposure = 1;
            this.renderer.physicallyCorrectLights = true;

            // this.renderer.shadowMap.enabled = true;

            // if (window.isiPad) {
            //     this.renderer.shadowMap.type = PCFSoftShadowMap;
            // }

            this.controls = new OrbitControls(this.camera, this.$el);
            this.controls.update();
            this.controls.enabled = true;
            this.controls.enableZoom = false;
            this.controls.enablePan = false;
            this.controls.maxPolarAngle = Math.PI / 2;
            this.controls.minPolarAngle = Math.PI / 2;
            this.controls.enableDamping = true;
            this.controls.dampingFactor = 0.05;

            this.setControls(this.controls);

            // Start the rendering loop:
            this.loop();
        });
    },
    methods: {
        ...mapActions('spinner', ['setup', 'setControls']),

        loop() {
            requestAnimationFrame(this.loop);
            this.render();
            this.controls.update();
        },

        updateCamera() {
            if (this.aspect < 1) {
                let fov =
                    2 *
                    Math.atan(
                        this.sceneWidth /
                            this.aspect /
                            (2 * this.camera.position.z)
                    ) *
                    (180 / Math.PI);
                this.camera.fov = fov;
                this.camera.updateProjectionMatrix();
            }
        },

        render() {
            // this.updateCamera();
            this.renderer.setScissor(0, 0, this.sliderPos, window.innerHeight);
            this.renderer.render(this.sceneLeft, this.camera);
            this.renderer.setScissor(
                this.sliderPos,
                0,
                window.innerWidth,
                window.innerHeight
            );
            this.renderer.render(this.sceneRight, this.camera);
        },

        updateSliderPos(pos) {
            this.sliderPos = pos;
        },

        onResize() {
            this.width = this.$el.offsetWidth;
            this.height = this.$el.offsetHeight;
            this.aspect = this.width / this.height;
            this.camera.aspect = this.width / this.height;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(this.width, this.height);
        },
    },

    watch: {
        loadFinished(isFinished) {
            if (isFinished) {
                gsap.killTweensOf('.slider');
                gsap.to('.slider', {
                    callbackScope: this,
                    delay: 1,
                    opacity: 1,
                    left: '50%',
                    ease: 'power4.out',
                    duration: 1,
                    onUpdate: () => {
                        this.sliderOverridePos = document.getElementsByClassName(
                            'slider'
                        )[0].offsetLeft;
                    },
                });
            } else {
                gsap.to('.slider', {
                    callbackScope: this,
                    duration: 0,
                    opacity: 0,
                    left: '10%',
                    onUpdate: () => {
                        this.sliderOverridePos = document.getElementsByClassName(
                            'slider'
                        )[0].offsetLeft;
                    },
                });
            }
        },
    },
};
</script>

<style></style>
